import Vue from 'vue';
import App from '@/App.vue';
import store from '@/store';
import i18n from '@/plugins/i18n';
import router from '@/router';
import '@/utils/vee-validate';
import mixpanel from 'mixpanel-browser';
import './assets/styles/tailwind.css';
import isMobile from '@/utils/isMobile';
import getUserOs from '@/helpers/detect-os';
mixpanel.init(process.env.VUE_APP_MIXPANEL_TOKEN, {
  persistence: 'localStorage',
});

Vue.config.productionTip = false;
const initialUrl = window.location.href;
Vue.prototype.$mixpanel = (
  eventName: string,
  event: { [key: string]: any } = {}
) => {
  const defaultEventProperties = {
    rb_id: store.getters['token'],
    rb_slug: store.getters['slug'],
    company_id: store.state.config?.company,
    parent_company_id:
      store.state.config?.parent || store.state.config?.company,
    session_id: store.state.surveyId,
    branch_name: store.state.activeBranchIdentifier,
    page_type: store.state.activeViewName,
    page_is_final: !store.state.isNextView,
    facility_id: store.state.defaultFacility?.id,
    initial_url: initialUrl,
    medium: isMobile() ? 'web_mobile' : 'web_desktop',
    system: getUserOs(),
  };
  mixpanel.track(eventName, { ...defaultEventProperties, ...event });
};

new Vue({
  store,
  i18n,
  router,
  render: h => h(App),
}).$mount('#app');
